import type { AvatarVariant } from '@schemer/shared';

// Which character portrait you get on your own role card. Purely cosmetic and
// team-neutral (every role has a woman AND a man version), so it never hints at
// anything. "Maakt niet uit" leaves it unset and the app picks a stable variant
// from your player id — that is the default, so nobody is forced to choose.
export function AvatarPicker({
  value,
  onChange,
  disabled,
}: {
  value: AvatarVariant | null;
  onChange: (v: AvatarVariant | null) => void;
  disabled?: boolean;
}): React.JSX.Element {
  const options: ReadonlyArray<{ v: AvatarVariant | null; label: string }> = [
    { v: null, label: 'maakt niet uit' },
    { v: 'v', label: 'vrouw' },
    { v: 'm', label: 'man' },
  ];
  return (
    <div className="avatar-pick">
      <span className="avatar-pick-label">Jouw personage</span>
      <div className="seg" role="radiogroup" aria-label="Jouw personage">
        {options.map((o) => (
          <button
            key={o.label}
            type="button"
            role="radio"
            aria-checked={value === o.v}
            className={`seg-opt${value === o.v ? ' on' : ''}`}
            disabled={disabled ?? false}
            onClick={() => onChange(o.v)}
          >
            {o.label}
          </button>
        ))}
      </div>
    </div>
  );
}
